/**
 * @generated SignedSource<<e10065de8b6bbb36ba480634356c0734>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpLiveDetails_viewer$data = {
  readonly nftBalancesByItem: ReadonlyArray<{
    readonly ownerAddress: {
      readonly address: string | null;
      readonly ensDomain: string | null;
      readonly publicProfile: {
        readonly profileName: string | null;
      } | null;
      readonly publicProfileUrl: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"NftAvatarCircle_address">;
    } | null;
  } | null> | null;
  readonly nftBenignNeglect: boolean | null;
  readonly walletConnectFeatureFlag: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"EndAuctionModal_viewer" | "NftPdpBidModal_viewer" | "SplitDetailsModal_viewer" | "useMarketSettings_viewer">;
  readonly " $fragmentType": "NftPdpLiveDetails_viewer";
};
export type NftPdpLiveDetails_viewer$key = {
  readonly " $data"?: NftPdpLiveDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpLiveDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "nftId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpLiveDetails_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "nftId",
          "variableName": "nftId"
        }
      ],
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "nftBalancesByItem",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ownerAddress",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftAvatarCircle_address"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ensDomain",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "publicProfileUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicProfile",
              "kind": "LinkedField",
              "name": "publicProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "walletConnectFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "allowWalletConnect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
    },
    {
      "alias": "nftBenignNeglect",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftBenignNeglect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpBidModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EndAuctionModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SplitDetailsModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMarketSettings_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "adea7df9da75d97a9eeb2a4a2b852d31";

export default node;
